import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { TranslateService } from '@ngx-translate/core';
import { timer } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AppConfigurationService } from 'src/app/services/app.configuration.service';
import { AuthService } from 'src/app/services/auth.service';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'app-mangopay-sca-validation',
  templateUrl: './mangopay-sca-validation.component.html',
  styleUrls: ['./mangopay-sca-validation.component.scss'],
})
export class MangopayScaValidationComponent implements OnInit {

  @Input() public isOwner: boolean = true;
  @Input() public hasConsentGranted: boolean = true;
  @Output() public finishEvent = new EventEmitter<any>();
  @Output() public removeModalEvent = new EventEmitter<any>();

  urlSafe: SafeResourceUrl;
  iframeLoaded: boolean = false;
  step: number = 0;

  text: string;
  image: number;
  btnList = [
    {
      type: 'primaryDark',
      index: 1,
      title: this.translate.instant('bid-create.continue'),
    }
  ];

  loading: boolean = false;
  private currentFlow: 'sca' | 'consent' | null = null;

  constructor(
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private profileService: ProfileService,
    private authService: AuthService,
    private appConfigurationService: AppConfigurationService
  ) { }

  ngOnInit() {
    if (!this.isOwner) {
      this.currentFlow = 'sca';
      this.startScaFlow();
    } else if (!this.hasConsentGranted) {
      this.currentFlow = 'consent';
      this.startConsentFlow();
    } else {
      this.finish();
      return;
    }

    window.addEventListener('message', e => {
      if (e.data.func === 'control_status') {
        const status = e.data.data.value.controlStatus;
        this.step = 1;
        this.loading = true;

        if (this.currentFlow === 'sca') {
          const validated = status === 'VALIDATED';
          if (validated) {
            this.setValidatedMessageParams();
          } else {
            this.image = 1;
            this.text = this.translate.instant('SCA.ISSUE');
          }
          this.profileService.saveCategorizeResult(validated).subscribe(() => {
            this.loading = false;
            if (validated && !this.hasConsentGranted) {
              this.step = 0;
              this.iframeLoaded = false;
              this.urlSafe = null;
              this.currentFlow = 'consent';
              this.startConsentFlow();
            } else {
              this.finish();
            }
            this.cdRef.detectChanges();
          });
        } else if (this.currentFlow === 'consent') {
          if (status === 'VALIDATED') {
            this.setValidatedMessageParams();
          } else {
            this.image = 1;
            this.text = this.translate.instant('SCA.ISSUE');
          }
          this.loading = false;
          this.finish();
        }
      }
      this.cdRef.detectChanges();
    });
    this.cdRef.detectChanges();
  }

  private startScaFlow() {
    this.profileService.categorizeUser().pipe(
      catchError(() => timer(2000).pipe(switchMap(() => this.profileService.categorizeUser())))
    ).subscribe(resp => {
      if (resp === 'Categorized' || resp.returnUrl === null) {
        if (!this.hasConsentGranted || resp.returnUrl === null) {
          this.currentFlow = 'consent';
          this.startConsentFlow();
        } else {
          this.setValidatedMessageParams();
          this.step = 1;
        }
      } else {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(resp.returnUrl);
      }
      this.cdRef.detectChanges();
    }, () => {
      this.step = 1;
      this.image = 1;
      this.text = this.translate.instant('SCA.ISSUE');
      this.loading = false;
      this.cdRef.detectChanges();
    });

  }

  private startConsentFlow() {
    this.profileService.getMangopayConsent().subscribe(resp => {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(resp.returnUrl);
      this.cdRef.detectChanges();
    }, error => {
      console.log(error, 'error');
    });
  }

  charged(event) {
    setTimeout(() => {
      this.iframeLoaded = true;
      this.cdRef.detectChanges();
    }, 1000);
    this.cdRef.detectChanges();
  }

  setValidatedMessageParams() {
    this.image = 6;
    this.text = this.translate.instant('SCA.CAN_CONTINUE');
    this.cdRef.detectChanges();
  }

  finish() {
    this.finishEvent.emit();
    this.cdRef.detectChanges();
  }

  removeModal() {
    this.removeModalEvent.emit();
    this.cdRef.detectChanges();
  }

}
